import { jsx } from 'react/jsx-runtime';
import { c as classNames, u as useEGDSContext } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-text.css';

/* 1DL type styles */
/** ******************* */
const EGDSDisplayStyleMap = [
    ['Display Medium', 'display-medium'],
    ['Display Small', 'display-small'],
];
new Map(EGDSDisplayStyleMap);
const EGDSHeadlineStyleMap = [
    ['Headline Extra Large', 'headline-extra-large'],
    ['Headline Large', 'headline-large'],
    ['Headline Medium', 'headline-medium'],
    ['Headline Small', 'headline-small'],
    ['Headline Overline', 'headline-overline'],
];
new Map(EGDSHeadlineStyleMap);
const EGDSTextStyleMap = [
    ['Text Large', 'text-large'],
    ['Text Medium', 'text-medium'],
    ['Text Small', 'text-small'],
];
new Map(EGDSTextStyleMap);
const EGDSParagraphStyleMap = [
    ['Paragraph Large', 'paragraph-large'],
    ['Paragraph Medium', 'paragraph-medium'],
    ['Paragraph Small', 'paragraph-small'],
];
new Map(EGDSParagraphStyleMap);
/* Type size */
/** ******************* */
const EGDSTypeSizeMap = [
    [100, 'uitk-type-100'],
    [200, 'uitk-type-200'],
    [300, 'uitk-type-300'],
    [400, 'uitk-type-400'],
    [500, 'uitk-type-500'],
    [600, 'uitk-type-600'],
    [700, 'uitk-type-700'],
    [800, 'uitk-type-800'],
    [900, 'uitk-type-900'],
];
const EGDSTypeSizes = new Map(EGDSTypeSizeMap);
/* Type weight */
/** ******************* */
const EGDSTypeWeightMap = [
    ['regular', 'uitk-type-regular'],
    ['medium', 'uitk-type-medium'],
    ['bold', 'uitk-type-bold'],
];
const EGDSTypeWeights = new Map(EGDSTypeWeightMap);
/* Type alignment */
/** ******************* */
const EGDSTypeAlignmentMap = [
    ['left', 'uitk-type-start'],
    ['right', 'uitk-type-end'],
    ['center', 'uitk-type-center'],
];
const EGDSTypeAlignments = new Map(EGDSTypeAlignmentMap);
/* Type overflow */
/** ******************* */
const EGDSTypeOverflowMap = [
    ['wrap', 'overflow-wrap'],
    ['truncate', 'truncate'],
    ['truncate-2-lines', 'truncate-lines-2'],
    ['truncate-3-lines', 'truncate-lines-3'],
    ['truncate-4-lines', 'truncate-lines-4'],
];
const EGDSTypeOverflows = new Map(EGDSTypeOverflowMap);
/* Type hyphens */
/** ******************* */
const EGDSTypeHyphensMap = [
    ['none', 'hyphens-none'],
    ['manual', 'hyphens-manual'],
    ['auto', 'hyphens-auto'],
];
const EGDSTypeHyphens = new Map(EGDSTypeHyphensMap);
/* Heading size */
/** ******************* */
const EGDSHeadingSizeMap = [
    [1, 'uitk-heading-1'],
    [2, 'uitk-heading-2'],
    [3, 'uitk-heading-3'],
    [4, 'uitk-heading-4'],
    [5, 'uitk-heading-5'],
    [6, 'uitk-heading-6'],
    [7, 'uitk-heading-7'],
    [8, 'uitk-heading-8'],
];
const EGDSHeadingSizes = new Map(EGDSHeadingSizeMap);
/* Paragraph size */
/** ******************* */
const EGDSParagraphSizeMap = [
    [1, 'uitk-paragraph-1'],
    [2, 'uitk-paragraph-2'],
    [3, 'uitk-paragraph-3'],
];
const EGDSParagraphSizes = new Map(EGDSParagraphSizeMap);
/* Type margin */
/** ******************* */
const EGDSTypeMarginMap = [
    ['half', 'uitk-text-spacing-half'],
    ['one', 'uitk-text-spacing-one'],
    ['two', 'uitk-text-spacing-two'],
    ['three', 'uitk-text-spacing-three'],
    ['four', 'uitk-text-spacing-four'],
    ['six', 'uitk-text-spacing-six'],
];
const EGDSTypeMargins = new Map(EGDSTypeMarginMap);
/* Heading tag */
/** ******************* */
const EGDSHeadingTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
];
const EGDSHeadingTags = new Map(EGDSHeadingTagMap);
const EGDSSubHeadingTagMap = [...EGDSHeadingTagMap, ['p', 'p']];
const EGDSSubHeadingTags = new Map(EGDSSubHeadingTagMap);
/* Type theme */
/** ******************* */
const EGDSTextThemeMap = [
    ['positive', 'uitk-text-positive-theme'],
    ['negative', 'uitk-text-negative-theme'],
    ['emphasis', 'uitk-text-emphasis-theme'],
    ['default', 'uitk-text-default-theme'],
    ['loyalty', 'uitk-text-loyalty-theme'],
    ['global-loyalty', 'uitk-text-global-loyalty-theme'],
    ['inverse', 'uitk-text-inverse-theme'],
    ['light', 'uitk-text-light-theme'],
    ['standard', 'uitk-text-standard-theme'],
    ['secondary', 'uitk-text-secondary-theme'],
];
const EGDSTextThemes = new Map(EGDSTextThemeMap);
/* Type white space */
/** ******************* */
const EGDSTypeWhiteSpaceMap = [
    ['normal', 'uitk-text-white-space-normal'],
    ['nowrap', 'uitk-text-white-space-nowrap'],
    ['pre', 'uitk-text-white-space-pre'],
    ['pre-wrap', 'uitk-text-white-space-pre-wrap'],
    ['pre-line', 'uitk-text-white-space-pre-line'],
    ['break-spaces', 'uitk-text-white-space-break-spaces'],
];
const EGDSTypeWhiteSpaces = new Map(EGDSTypeWhiteSpaceMap);
/* Text inline (phrase) tags */
/** ******************* */
const EGDSTextInlineTagsMap = [
    ['b', 'b'],
    ['em', 'em'],
    ['s', 's'],
    ['small', 'small'],
    ['i', 'i'],
    ['mark', 'mark'],
    ['strong', 'strong'],
    ['q', 'q'],
    ['sub', 'sub'],
    ['sup', 'sup'],
];
const EGDSTextInlineTags = new Map(EGDSTextInlineTagsMap);

const getClassNameList$3 = classNames.bind(styles);
/**
 * Use for title/headings of pages, sections, articles, listings, rate plans, etc.
 * Ensure that you are choosing the correct semantic `tag` for your heading.
 */
const EGDSHeading = (props) => {
    const { align, children, className, tag, size, overflow, hyphens, domRef, typeStyle, ...attributes } = props;
    const Tag = ((tag && EGDSHeadingTags.get(tag)) || EGDSHeadingTags.get('h3'));
    const { data: contextData, context } = useEGDSContext();
    const { bottomScrimContext, overlayScrimContext, contextClassNames } = contextData ?? {};
    const wrapperClassNames = getClassNameList$3('uitk-heading', align && EGDSTypeAlignments.get(align), !bottomScrimContext && ((size && EGDSHeadingSizes.get(size)) || EGDSHeadingSizes.get(6)), overflow && EGDSTypeOverflows.get(overflow), hyphens && EGDSTypeHyphens.get(hyphens), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, context === 'uitk-dialog-context' && 'in-dialog', contextClassNames?.EGDSHeading, className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
    return children ? (jsx(Tag, { className: wrapperClassNames, ref: domRef, ...(typeStyle && { 'type-style-theme': typeStyle.customTheme || 'standard' }), ...attributes, children: children })) : null;
};
EGDSHeading.displayName = 'EGDSHeading';

const getClassNameList$2 = classNames.bind(styles);
const EGDSParagraph = (props) => {
    const { size, children, className, typeStyle, ...attributes } = props;
    const { data: contextData, context } = useEGDSContext();
    const { bottomScrimContext, overlayScrimContext, contextClassNames } = contextData ?? {};
    const baseClassName = 'uitk-paragraph';
    const wrapperClassNames = getClassNameList$2(baseClassName, !bottomScrimContext && size && EGDSParagraphSizes.get(size), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, context === 'uitk-dialog-context' && 'in-dialog', contextClassNames?.EGDSParagraph, className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
    return children ? (jsx("p", { className: wrapperClassNames, ...(typeStyle && { 'type-style-theme': typeStyle.customTheme || 'standard' }), ...attributes, children: children })) : null;
};
EGDSParagraph.displayName = 'EGDSParagraph';
EGDSParagraph.defaultProps = {
    size: 2,
};

const getClassNameList$1 = classNames.bind(styles);
/**
 * Use only for subheadings, which immediately follow a heading.
 * Should not be used standalone or inline with other content.
 */
const EGDSSubheading = (props) => {
    const { align, className, children, tag, overflow, hyphens, ...attributes } = props;
    const defaultTag = 'p';
    const Tag = (tag && EGDSSubHeadingTags.get(tag)) || defaultTag;
    const { data: contextData } = useEGDSContext();
    const { bottomScrimContext, overlayScrimContext, contextClassNames } = contextData ?? {};
    const wrapperClassNames = getClassNameList$1('uitk-subheading', align && EGDSTypeAlignments.get(align), overflow && EGDSTypeOverflows.get(overflow), hyphens && EGDSTypeHyphens.get(hyphens), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, contextClassNames?.EGDSSubheading, className);
    return children ? (jsx(Tag, { className: wrapperClassNames, ...attributes, children: children })) : null;
};

const getClassNameList = classNames.bind(styles);
/**
 * Use for freestanding text elements that are not a list, paragraph, or heading.
 * Should not replace the usage of lists or headings.
 */
const EGDSText = (props) => {
    const { align, children, inline, size: passedInSize, spacing, overflow, weight, whiteSpace, className, theme = 'default', wordBreak = false, dataTestId, hyphens, typeStyle, ...attributes } = props;
    const isPhraseTag = inline && typeof inline === 'string';
    const size = !isPhraseTag && !passedInSize ? 300 : passedInSize;
    let Tag;
    if (inline && typeof inline === 'boolean') {
        Tag = 'span';
    }
    else if (isPhraseTag) {
        Tag = inline;
    }
    else {
        Tag = 'div';
    }
    const { data: contextData } = useEGDSContext();
    const { bottomScrimContext, overlayScrimContext, contextClassNames } = contextData ?? {};
    const wrapperClassNames = getClassNameList('uitk-text', align && EGDSTypeAlignments.get(align), spacing && EGDSTypeMargins.get(spacing), overflow && !inline && EGDSTypeOverflows.get(overflow), wordBreak && !inline && EGDSTypeOverflows.get('wrap'), hyphens && EGDSTypeHyphens.get(hyphens), !bottomScrimContext && size && EGDSTypeSizes.get(size), !bottomScrimContext && weight && EGDSTypeWeights.get(weight), whiteSpace && EGDSTypeWhiteSpaces.get(whiteSpace), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, !(bottomScrimContext || overlayScrimContext) && theme && EGDSTextThemes.get(theme), contextClassNames?.EGDSText, className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
    return children ? (jsx(Tag, { className: wrapperClassNames, ...(dataTestId ? { 'data-test-id': dataTestId } : {}), ...(typeStyle && { 'type-style-theme': typeStyle.customTheme || 'standard' }), ...attributes, children: children })) : null;
};
EGDSText.displayName = 'EGDSText';

export { EGDSHeading as E, EGDSParagraph as a, EGDSSubheading as b, EGDSText as c, EGDSTypeSizes as d, EGDSTypeWeights as e, EGDSTypeAlignments as f, EGDSTypeOverflows as g, EGDSTypeHyphens as h, EGDSHeadingSizes as i, EGDSParagraphSizes as j, EGDSTypeMargins as k, EGDSHeadingTags as l, EGDSSubHeadingTags as m, EGDSTextThemes as n, EGDSTypeWhiteSpaces as o, EGDSTextInlineTags as p };
//# sourceMappingURL=index-chunk.esm.js.map
